module.exports = __webpack_public_path__ + "static/media/ic_plus.ecdb5e88.png";